import get from 'lodash/get';
import { useMemo } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { CSSObject } from 'styled-components';

import { BuiltInComponents } from 'craft/constants';
import { CssSelectorId } from 'craft/types';

import { EditorStyleguideState } from './reducer';

export const selectStyleguide = ({ styleguide }: RootStateOrAny): EditorStyleguideState =>
  styleguide;

const EMPTY_OBJ = {};

const selectStyleguideCss = (
  type: string = BuiltInComponents.Multiple,
  variant?: string,
  cssSelectorId: CssSelectorId = CssSelectorId.Root,
) =>
  createSelector(selectStyleguide, (styleguide: EditorStyleguideState) => {
    if (type === BuiltInComponents.Multiple) {
      return EMPTY_OBJ;
    }

    return (
      get(styleguide, `${type}.${variant || 'base'}.${cssSelectorId}`) ?? (EMPTY_OBJ as CSSObject)
    );
  });

export const useStyleguideCss = (
  type?: string,
  variant?: string,
  cssSelectorId?: CssSelectorId,
): CSSObject => {
  const selector = useMemo(() => selectStyleguideCss(type, variant, cssSelectorId), [
    type,
    variant,
    cssSelectorId,
  ]);
  return useSelector(selector);
};
